export default __webpack_public_path__ + "static/media/off-27.7986e62c.png";